import { render, staticRenderFns } from "./ListaExames.vue?vue&type=template&id=eb1658be&scoped=true&"
import script from "./ListaExames.vue?vue&type=script&lang=js&"
export * from "./ListaExames.vue?vue&type=script&lang=js&"
import style0 from "./ListaExames.vue?vue&type=style&index=0&id=eb1658be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb1658be",
  null
  
)

export default component.exports